import axios from 'axios';
import { LoggedUser } from '../types';

export const getToken = (): LoggedUser | null => {
  const loggedUser = localStorage.getItem('USER');
  return loggedUser ? JSON.parse(loggedUser) : null;
};

export const setToken = (data: LoggedUser) =>
  localStorage.setItem('USER', JSON.stringify({ token: data.token, expires: data.expires }));

export const insertTokenIntoHttp = (token: string | null) =>
  (axios.defaults.headers.common['Authorization'] = `Bearer ${token}`);
